import { app } from '../../../../../../app';
import { Controller } from './directory-manage-connection-scim.controller';

app.component('companyDirectoryIntegrationManageConnectionScim', {
    bindings: {
        conConfig: '<',
        companyId: '<',
        directoryId: '<',
    },
    controller: Controller,
    templateUrl: require('./directory-manage-connection-scim.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/scim/connection/directory-manage-connection-scim.component.js